var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"__loading"},[_c('v-overlay',{attrs:{"value":_vm.overlay,"color":"white"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }